<script setup lang="ts">
defineProps<{ mode: 'open' | 'close' }>()

const searchMode = defineModel<boolean>('searchMode', { default: false })

const { open } = useLawView()
const { searchTerm, commit, submit, reset } = useLawSearchQuery()

function onSearchInput(value: string) {
  searchMode.value = !!value
  commit(value)
}

function onSearchSubmit() {
  const trimmed = searchTerm.value.trim()
  searchMode.value = !!trimmed
  // Search results (LawSearch) render in the toc view; switch to it so they're visible when submitting from the reading view.
  if (trimmed) {
    open('toc')
  }
  submit(searchTerm.value)
}

function onSearchReset() {
  searchMode.value = false
  reset()
}
</script>

<template>
  <ReadingMobileTableOfContentBar :mode="mode" view-key="law-view-stack" open-label="Åpne innhold og søk">
    <form role="search" class="flex-1" @submit.prevent="onSearchSubmit">
      <FormSearchInput
        :id="`law-commentary-mobile-search-${mode}`"
        v-model="searchTerm"
        class="w-full"
        shape="square"
        size="medium"
        name="lcq-mobile"
        color="carbon"
        label="Søk i loven"
        placeholder="Søk i loven"
        resettable
        @reset="onSearchReset"
        @update:model-value="onSearchInput"
      />
    </form>
  </ReadingMobileTableOfContentBar>
</template>
